module.exports = __webpack_public_path__ + "img/badge.012add1d.png";